<template>
    <div class="home-page">
        <transition :name="transitionName">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
        </transition>
        <transition :name="transitionName">
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </transition>

        <van-tabbar
            class="tabbar"
            v-model="active"
            active-color="#f2ad47"
            inactive-color="#444"
            :route="true"
        >
            <van-tabbar-item to="/index">
                <span>首页</span>
                <img
                    class="index-logo"
                    slot="icon"
                    slot-scope="props"
                    :src="props.active ? nav1ImgActive : nav1Img"
                />
            </van-tabbar-item>
            <van-tabbar-item to="/course-list">
                <span>已购</span>
                <img
                    class="study-logo"
                    slot="icon"
                    slot-scope="props"
                    :src="props.active ? nav2ImgActive : nav2Img"
                />
            </van-tabbar-item>
            <van-tabbar-item @click="goQxb()">
                <span>情绪宝</span>
                <img
                    class="qxb-logo"
                    slot="icon"
                    slot-scope="props"
                    :src="props.active ? nav3ImgActive : nav3Img"
                />
                <img class="xin" src="~@/assets/xin.png" alt="" />
            </van-tabbar-item>
            <van-tabbar-item to="/user-center">
                <span>我的</span>
                <img
                    class="my-logo"
                    slot="icon"
                    slot-scope="props"
                    :src="props.active ? nav4ImgActive : nav4Img"
                />
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    import Nav1Img from "../../assets/nav1.png";
    import Nav2Img from "../../assets/nav2.png";
    import Nav3Img from "../../assets/nav3.png";
    import Nav4Img from "../../assets/nav4.png";
    import Nav1ImgActive from "../../assets/nav1-active.png";
    import Nav2ImgActive from "../../assets/nav2-active.png";
    import Nav3ImgActive from "../../assets/nav3-active.png";
    import Nav4ImgActive from "../../assets/nav4-active.png";
    export default {
        name: "home",
        components: {},
        data() {
            return {
                active: 0,
                nav1Img: Nav1Img,
                nav2Img: Nav2Img,
                nav3Img: Nav3Img,
                nav4Img: Nav4Img,
                nav1ImgActive: Nav1ImgActive,
                nav2ImgActive: Nav2ImgActive,
                nav3ImgActive: Nav3ImgActive,
                nav4ImgActive: Nav4ImgActive,
                isShowRechage: false,
                transitionName: "",
            };
        },

        methods: {
            goQxb() {
                location.href = "/emotion4/index";
            },
        },
        watch: {
            $route(to, from) {
                this.transitionName = "";
                if (from.path == "/search" && to.path == "/index") {
                    this.transitionName = "slide-left";
                }
                if (from.path == "/index" && to.path == "/search") {
                    this.transitionName = "slide-right";
                }
            },
        },
    };
</script>

<style lang="scss" scoped src="./home.scss"></style>
